import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { Icon, Avatar } from 'antd'
import ImageUploader from './ImageUploader'
import { ButtonConstant } from '../../constants'
import { getGCSUrl, resolveAfter, openNotification } from '../../services/Common'
import { NotificationService } from '../../legacy_components/services/NotificationService'
import { UPLOAD_TIMEOUT_DURATION } from '../../constants/Durations'
import 'cropperjs/dist/cropper.css'
import { isMobile } from 'react-device-detect';
import TuringHelpBtn from '../../legacy_components/UI_V2_Components/shared/TuringHelpBtn/TuringHelpBtn';

class UploadAvatar extends Component {
  imgElement = null

  isUnmounted = false

  state = {
    isImageUploaderVisible: false,
    isUploading: false,
  }

  componentWillUnmount() {
    this.isUnmounted = true
  }

  hideImageUploader = () => {
    this.setState({ isImageUploaderVisible: false })
  }

  showImageUploader = () => {
    this.setState({ isImageUploaderVisible: true })
  }

  handleContextMenuClick = event => {
    this.showImageUploader()
    event.preventDefault()
    event.stopPropagation()
  }

  handleAvatarClick = () => {
    this.showImageUploader()
  }

  uploadAvatarWithTimeout = async file => {
    const timeoutValue = 'timedOut'
    const result = await Promise.race([
      resolveAfter(UPLOAD_TIMEOUT_DURATION, timeoutValue),
      this.props.onUpdateAvatar({
        dialogState: ButtonConstant.DIALOG_EDIT,
        avatorFile: file,
      }),
    ])

    if (result === timeoutValue)
      NotificationService.error('Error', null, { description: 'Server took too long to respond', duration: 5 })
  }

  handleUploadAvatar = async file => {
    this.setState({ isUploading: true })

    await this.uploadAvatarWithTimeout(file)
    
    if (!this.isUnmounted) {
      this.setState({ isUploading: false })
    }
  }

  render () {
    const { avatarUrl, inline, disableImageUpload, enable_linkedin_sync } = this.props
    const { isImageUploaderVisible, isUploading } = this.state
    const imgSrc = avatarUrl ? `${getGCSUrl()}/avatar/${avatarUrl}` : ''

    return (
      <div className={`profile-img-holder ${enable_linkedin_sync ? 'new': ''}`}>
        <div
          className="profile-img-avatar-container"
          onClick={!inline ? this.handleAvatarClick : undefined}
          onContextMenu={!inline ? this.handleContextMenuClick : undefined}
        >
          <Avatar
            size={ isMobile ? 64 : 96 }
            shape="circle"
            icon="user"
            className="profile-img"
            src={imgSrc || "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"}
            ref={this.handleAddImgRef}
            style={inline && { cursor: 'default' }}
          />
          {!enable_linkedin_sync ?
            <TuringHelpBtn help="High resolution professional-looking photo can make your resume look more marketable. Selfies look good on social media, but not on a Resume 🤳">
              <button
                type="button"
                className={`ant-btn ${inline ? '' : ' ant-btn-circle ant-btn-icon-only edit'}`}
                title={inline ? 'Upload image' : 'edit'}
                style={inline && { marginLeft: 50 }}
                onClick={inline ? this.handleAvatarClick : undefined}
                onContextMenu={inline ? this.handleContextMenuClick : undefined}
                disabled={disableImageUpload}
              >
                <span className={`${inline ? '' : 'material-icons MuiIcon-root material-icons-round' }`} aria-hidden="true">{inline ? 'Upload profile photo' : 'edit'}</span>
              </button>
            </TuringHelpBtn> :
            <button
                type="button"
                className={`ant-btn-link ${inline ? '' : ' ant-btn-circle ant-btn-icon-only edit'}`}
                title={inline ? 'Upload image' : 'edit'}
                style={inline && { marginLeft: 26 }}
                onClick={inline ? this.handleAvatarClick : undefined}
                onContextMenu={inline ? this.handleContextMenuClick : undefined}
                disabled={disableImageUpload}
              >
                <span className={`${inline ? '' : 'material-icons MuiIcon-root material-icons-round' }`} aria-hidden="true">{inline ? 'Upload profile photo' : 'edit'}</span>
            </button>
          }
        </div>
        
        {isUploading && (
          <div className="profile-img-loading">
            <Icon type="loading" />
          </div>
        )}
        <ImageUploader
          isVisible={isImageUploaderVisible}
          onHide={this.hideImageUploader}
          onUpload={this.handleUploadAvatar}
        />
      </div>
    )
  }
}

UploadAvatar.propTypes = {
  avatarUrl: PropTypes.string,
  inline: PropTypes.bool,
  disableImageUpload: PropTypes.bool
}

export default UploadAvatar;
